import * as filters from "@/common/filters";

export default defineNuxtPlugin((nuxtApp) => {
  // 提供给 useNuxtApp().$filters 使用
  nuxtApp.provide("filters", filters);

  const globals = nuxtApp.vueApp.config.globalProperties;

  // 避免重复定义 $filters
  const desc = Object.getOwnPropertyDescriptor(globals, "$filters");
  if (!desc) {
    Object.defineProperty(globals, "$filters", {
      get() {
        return filters;
      },
      configurable: true,
      enumerable: true,
    });
  }

  // 将每个过滤器作为全局方法添加（防止重复定义）
  Object.keys(filters).forEach((key) => {
    if (!Object.getOwnPropertyDescriptor(globals, key)) {
      Object.defineProperty(globals, key, {
        get() {
          return filters[key];
        },
        configurable: true,
        enumerable: true,
      });
    }
  });
});
